import { render, staticRenderFns } from "./WarrantyComponent.vue?vue&type=template&id=436db9df"
import script from "./WarrantyComponent.vue?vue&type=script&lang=js"
export * from "./WarrantyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports